
const Util 			= require('../../../common/util.js');
const queryString 	= Util.queryString;

const sideThumbHeight = 98
const itemHeight = sideThumbHeight + 2;
const onePageHeight = 4 * itemHeight;
	
// 初始化酒店小图组的上下滚动事件
const initSmallImgListScroll = function(){
	$(".hotel-detail-info-outer").delegate('.hdi-img-wrap-small', 'mouseover', function() {
		$(this).find('.hdi-img-scroll').show();
	}).delegate('.hdi-img-wrap-small', 'mouseout', function() {
		$(this).find('.hdi-img-scroll').hide();
	})

	$(".hotel-detail-info-outer").delegate('.hdi-img-scroll', 'click', function(){
		var
			_this = $(this),
			parent = _this.closest('.hdi-img-wrap-small'),
			upIcon = parent.find('.scroll-up'),
			downIcon = parent.find('.scroll-down'),
			target = parent.find('.hdi-img-small-list'),
			liCount = target.find('li').length,
			targetHeight = liCount * sideThumbHeight + (liCount - 1) * 2;

		var offsetY;
		var translateY = -parseInt( target.css('margin-top') );

		if(_this.hasClass('scroll-down')){
			if(downIcon.hasClass('disabled'))	return;
			
			upIcon.removeClass('disabled');

			var nextStep = translateY + onePageHeight;

			if(targetHeight - nextStep < onePageHeight) {
				offsetY = targetHeight - 412;
				downIcon.addClass('disabled');
			}else{
				offsetY = nextStep;
			}
		}else{
			if(upIcon.hasClass('disabled'))	return;

			downIcon.removeClass('disabled');
			
			var nextStep = translateY - onePageHeight;

			if(nextStep <= 0) {
				offsetY = 0;
				upIcon.addClass('disabled');
			}else{
				offsetY = nextStep;
			}
		}

		const topNodesCount = Math.ceil(offsetY / itemHeight);
		const $sliderNodes = $(".hotel-detail-info-outer .hdi-img-small-list .hdi-img-small-item");
		const currentImageUrl = $($sliderNodes[topNodesCount]).find('.hide-img-thumb').attr('src');

		$sliderNodes.removeClass('active');
		$($sliderNodes[topNodesCount]).addClass('active');
		target.animate({'margin-top': -offsetY}, 200);
		showImageInAlbums(currentImageUrl);
		updateHorizontalBtn(topNodesCount, $sliderNodes.length);
	})
};
	
// 初始化酒店小图的点击事件
const initSmallImgClick = function(){
	$(".hotel-detail-info-outer").delegate('.hdi-img-small-item', 'click', function(){
		var _this = $(this), $sliderNodes, thisImgSrc;
			
		if(_this.hasClass('active')) return;
		
		thisImgSrc = _this.find('.hide-img-thumb').attr('src');
		showImageInAlbums(thisImgSrc);
		$sliderNodes = _this.closest('.hdi-img-small-list').find('.hdi-img-small-item');
		$sliderNodes.removeClass('active');
		_this.addClass('active');
		updateHorizontalBtn(_this.data('index'), $sliderNodes.length);
	})
};

const showImageInAlbums = function(url) {
	$(".hotel-detail-info-outer .hdi-img-wrap-big .hdi-img-source").attr('src', url);
}

const initHorizontalScroll = function() {
	$(".hotel-detail-info-outer").delegate('.hdi-img-wrap-big', 'mouseover', function() {
		$(this).find('.hdi-scroll-btn').show();
	}).delegate('.hdi-img-wrap-big', 'mouseout', function() {
		$(this).find('.hdi-scroll-btn').hide();
	})

	$(".hotel-detail-info-outer").delegate('.hdi-scroll-btn', 'click', function(){
		var $this = $(this);

		if($this.hasClass('disabled'))	return;

		const $list = $(".hotel-detail-info-outer .hdi-img-small-list");
		const $sliderNodes = $list.children(".hdi-img-small-item");
		const total = $sliderNodes.length;
		const listHeight = total * sideThumbHeight + (total - 1) * 2;
		const translateY = -parseInt( $list.css('margin-top') );
		const topNodesCount = Math.ceil(translateY / itemHeight);
		let next;

		$sliderNodes.each((index, item) => {
			let $node = $(item);

			if($node.hasClass('active')) {
				if($this.hasClass('left')) {
					next = index - 1;
				}else{
					next = index + 1;
				}

				$node.removeClass('active');
			}
		})

		let $current = $($sliderNodes[next]);
		let offsetY;

		// 上一页
		if(next < topNodesCount) {
			// 第一页
			if(topNodesCount <= 4) {
				offsetY = 0
			}else{
				offsetY = (topNodesCount - 4) * itemHeight
			}

		}else if(next > (topNodesCount + 3)){ // 下一页
			// 最后一页
			if(total - next <= 4) {
				offsetY = listHeight - 412;
			}else{
				offsetY = (topNodesCount + 4) * itemHeight
			}
		}

		if(offsetY >= 0) {
			const $parent = $(".hotel-detail-info-outer .hdi-img-wrap-small");
			const $topBtn = $parent.children('.scroll-up');
			const $bottomBtn = $parent.children('.scroll-down');

			$list.animate({'margin-top': -offsetY}, 200);

			if(offsetY === 0) {
				$topBtn.addClass('disabled');

				if(listHeight > 412) {
					$bottomBtn.removeClass('disabled');
				}
			}else if(listHeight > 412) {
				if(offsetY === (listHeight - 412)) {
					$topBtn.removeClass('disabled')
					$bottomBtn.addClass('disabled');
				}else{
					$bottomBtn.removeClass('disabled');
				}
			}
		}

		$current.addClass('active');
		showImageInAlbums($current.find('.hide-img-thumb').attr('src'));
		updateHorizontalBtn(next, $sliderNodes.length);
	})
}

const updateHorizontalBtn = function(index, total) {
	const $parent = $(".hotel-detail-info-outer .hdi-img-wrap-big");
	const $leftBtn = $parent.children('.left');
	const $rightBtn = $parent.children('.right');

	if(index === 0) {
		$leftBtn.addClass('disabled');
		$rightBtn.removeClass('disabled');
	}else{
		$leftBtn.removeClass('disabled');

		if(index === total - 1) {
			$rightBtn.addClass('disabled');
		}else{
			$rightBtn.removeClass('disabled');
		}
	}
}

const initHotelInfoFolder = function() {
	$(".hotel-detail-info-outer").delegate('.hdi-brief-view-detail', 'click', function() {
		const $content = $(this).closest('.hdi-brief-item-content');
		const text = $content.data('content')

		$content.html(text)
	})
}

// 酒店信息
module.exports = {
    run: function(){
    	
    	// 初始化酒店小图组的上下滚动事件
		initSmallImgListScroll();
		
		initHorizontalScroll();
    	
    	// 初始化酒店小图的点击事件
		initSmallImgClick();
		
		initHotelInfoFolder();
    }
}


// WEBPACK FOOTER //
// ./src/js/hotelDetail/modules/hotelInfo.js